import React, { useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import {
  getProgramDisplayLabel,
  getProgramNameFromId,
} from '@lyrahealth-inc/shared-app-logic/src/features/programConfigs/programHelpers'

import { ClientFiltersCheckboxSection } from './ClientFiltersCheckboxSection'

export enum NextSession {
  SCHEDULED = 'SCHEDULED',
  UNSCHEDULED_LESS_30_DAYS = 'UNSCHEDULED_LESS_30_DAYS',
  UNSCHEDULED_MORE_30_DAYS = 'UNSCHEDULED_MORE_30_DAYS',
}
export type ClientFiltersProgramSectionProps = {
  programs: string[]
  values: string[]
  onChange: (values: string[]) => void
}

export const ClientFiltersProgramSection: React.FC<ClientFiltersProgramSectionProps> = ({
  programs,
  values,
  onChange,
}) => {
  const intl = useIntl()
  const programItems = useMemo(
    () =>
      programs.map((program) => {
        const name = getProgramNameFromId(program)
        return {
          id: program,
          text: getProgramDisplayLabel(intl, name),
        }
      }),
    [intl, programs],
  )
  return (
    <ClientFiltersCheckboxSection
      title={<FormattedMessage defaultMessage='Program' description='Program filter section' />}
      items={programItems}
      values={values}
      onChange={onChange}
      name='programs'
    />
  )
}
